import {registerJQueryComponent} from '@lib/JQueryRegistry'
import LoginFormField from './LoginFormField';

export default class LoginSelectFormField extends LoginFormField {
    constructor(rootElement) {
        super(rootElement);
        this.$dom.input = rootElement.find('select');
    }

    isValid() {
        return true;
    }
}

registerJQueryComponent(LoginSelectFormField, '.login-form-field-select')